import type { ReactElement } from 'react';
import { useMonthlyCost } from '../lib/queries';
import { useT } from '../lib/i18n';
import { formatDateShort, formatMonthName } from '../lib/format';
import { reaisDeMicros, reaisDoTotal, valorDoExtrato } from '../lib/precos-meta';
import { useMostrarCustos } from '../lib/mostrar-custos';
import { Icon } from './Icon';
import { useTip } from './Tip';

/** O gasto estimado com mensagens no mês da operação. Informativo (ADR 0030). */
export function CustoDoMes({ ativo }: { readonly ativo: boolean }): ReactElement | null {
  const t = useT();
  const tip = useTip();
  const custo = useMonthlyCost(ativo);
  const [mostrar, alternar] = useMostrarCustos();
  const c = custo.data;
  if (c === undefined) return null;

  const partes =
    c.partnerMicros === 0
      ? `Meta ${reaisDeMicros(c.metaMicros)}`
      : t.custo.partes(reaisDeMicros(c.metaMicros), reaisDeMicros(c.partnerMicros));

  const extrato =
    c.billed === null
      ? ''
      : ` ${
          c.billed.throughDay === null
            ? t.custo.semExtrato
            : t.custo.debitado(
                valorDoExtrato(c.billed.totalMicros, c.billed.currency),
                formatDateShort(c.billed.throughDay),
              )
        }.`;
  const rotuloDoOlho = mostrar ? t.custo.esconder : t.custo.mostrar;

  return (
    <div className={`custo-mes${mostrar ? '' : ' is-oculto'}`}>
      <div className="custo-mes__linha">
        <span className="custo-mes__rotulo">{t.custo.doMes(formatMonthName(c.month))}</span>
        <button
          type="button"
          className="custo-mes__olho"
          onClick={alternar}
          aria-pressed={!mostrar}
          aria-label={rotuloDoOlho}
          {...tip(rotuloDoOlho)}
        >
          <Icon name={mostrar ? 'eye' : 'eye-off'} size={14} />
        </button>
      </div>
      <span
        className="custo-mes__valor num"
        {...(mostrar ? tip(`${t.custo.explicacao} ${partes}.${extrato}`) : {})}
      >
        {mostrar ? reaisDoTotal(c.totalMicros) : 'R$ ••••'}
      </span>
      {mostrar ? (
        <p className="custo-mes__sub">
          {t.custo.quantas(c.messages)} · {t.custo.estimativa}
        </p>
      ) : null}
    </div>
  );
}
